import React, { Component } from 'react'
import moment from 'moment-timezone'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import VitalSigns from '../components/VitalSigns'
import DataList from '../components/DataList'
import Notification from '../components/Notification'
import Timeline from '../components/Timeline/Timeline'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import { getPatientSnapshot, getPatient, getPatientNotes, createNote } from '../api'
import { aggregateEntries, summarizeSymptoms, orderByDate } from '../utils'
import { DEFAULT_TIMEZONE } from '../constants'

const styles = theme => ({
  page: {
    display: 'flex',
    height: 'calc(100% - 90px)',
    width: '100%',
    overflow: 'scroll'
  },
  left: {
    padding: '60px 0',
    width: 'calc(45% - 10px)',
  },
  right: {
    padding: '60px 0',
    paddingLeft: 60,
    width: '55%',
    boxSizing: 'border-box',
  },
  verticalDivider: {
    width: 1,
    height: '100%',
    backgroundColor: theme.borderColor,
    position: 'fixed',
    top: 70,
    bottom: 0,
    left: 'calc(45% + 157px)',
    zIndex: 100
  },
  header: {
    fontSize: '1.5rem',
    padding: '15px 0'
  },
  title: {
    fontWeight: 'bold',
    marginBottom: 20
  },
  leftPadding: {
    paddingLeft: 60
  },
  divider: {
    margin: '20px 0'
  },
  lastUpdated: {
    color: 'silver',
    marginLeft: 10
  },
  flex: {
    display: 'flex'
  },
})

class Today extends Component {
  constructor (props) {
    super(props)

    this.state = {
      snapshot: {},
      patient: props.patient,
      mostRecentNote: ''
    }
  }

  componentDidMount () {
    const { id } = this.props.patient
    this.fetchPatientData()
  }

  fetchPatientData = () => {
    const { id } = this.props.patient

    getPatientNotes(id).then(patientNotes => {
      this.setMostRecentNote(patientNotes)
    })

    this.interval = window.setInterval(() => {
      getPatient(id).then(patientData => {
        this.props.updatePatient(patientData)
      })
    }, 1000)
  }

  setMostRecentNote = notes => {
    const mostRecentNote = orderByDate(notes, 'time').reverse()[0]
    if (mostRecentNote) {
      this.setState({mostRecentNote: mostRecentNote.text})
    }
  }

  saveNewNote = () => {
    createNote(this.props.patient.id, {
      time: moment.utc().tz(DEFAULT_TIMEZONE),
      text: this.state.mostRecentNote
    })
  }

  componentWillUnmount () {
    window.clearInterval(this.interval)
  }

  todaysNotifications() {
    const { notifications } = this.props.patient
    return notifications.filter(notification => {
      return moment.utc().tz(DEFAULT_TIMEZONE).isSame(notification.time, 'day') || !notification.end
    })
  }



  render() {
    const { classes, patient } = this.props
    const { snapshot } = this.state
    const { temperature, temperature_url, ecg, ecg_url, respiratory, respiratory_url, notifications } = patient
    if (!patient || !snapshot) return <div/>
    const entries = summarizeSymptoms(aggregateEntries(snapshot, false))

    return (
      <div className={classes.page}>
        <div className={classes.left}>
          <div className={classes.leftPadding}>
            <Typography className={classes.header}>Today {moment.utc().tz(DEFAULT_TIMEZONE).format('MMMM Do YYYY')}</Typography>
            <VitalSigns
              onClick={e => {}}
              vitals={{ temperature, temperature_url, ecg, ecg_url, respiratory, respiratory_url }} lastUpdated
              lastUpdated={ patient.last_reading_timestamp }
            />
          </div>
          <div className={classes.leftPadding}>
            <Typography className={classes.header}>Note</Typography>
              <TextField
                fullWidth
                multiline
                value={this.state.mostRecentNote}
                onChange={e => this.setState({mostRecentNote: e.currentTarget.value})}
              />
              <Button
                fullWidth
                onClick={e => this.saveNewNote()}
              >
                Submit
              </Button>
          </div>
          <div className={classes.leftPadding}>
            <Typography className={classes.header}>Notifications</Typography>
            {
              orderByDate(this.todaysNotifications(), 'time').reverse().map(notification => (
                <Notification notification={notification}/>
              ))
            }
          </div>
        </div>
        <div className={classes.verticalDivider} />
        <div className={classes.right}>
          <Typography className={classes.header}>Daily Log</Typography>
          <Timeline patient={patient} date={new Date()} refetch/>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(Today)



// WEBPACK FOOTER //
// ./src/pages/Today.js